import React from 'react';
import { Result } from 'antd';

const ErrorPage = () => <Result title="404" subTitle="Sorry, the page you visited does not exist." />;

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/js/views/404page/index.jsx